export const SAGA_SIGN_IN = 'SAGA_SIGN_IN';
export const SET_ACCOUNT = 'SET_ACCOUNT';


// WEBPACK FOOTER //
// ./src/Auth/actions.js